<template>
  <pt-group-table class="pt-group-table__withData" @get-group-list="groupList" :page-size="pageSize"
  :total-number="totalNumber" :table-data="tableData" :tableLabels="tableLabels" :loading="loading" ref="table">
  <slot/>
  </pt-group-table>
</template>

<script>
import PtGroupTable from './index'
export default {
  name: 'pt-group-table__withData',
  components: {
    'pt-group-table': PtGroupTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      page_size: this.pageSize,
      page: 0,
      totalNumber: 0,
      tableData: [],
      loading: false
    }
  },
  methods: {
    groupList (page, next) {
      this.page = page
      let data = {
        pageable: {
          page: page,
          size: this.page_size
        }
      }
      this.$store.dispatch('groupWithGoodsCount', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取商品分组列表失败')
      })
    }
  }
}
</script>
